module.exports = __webpack_public_path__ + "static/img/meishulv.c7ab094.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/meishulv.jpg
// module id = Zo57
// module chunks = 0